export default function getNumberFromAny(val: any, defaultVal: number): number {
    if (val !== undefined && !isNaN(Number(val)) && Number(val) > 0) {
        return Number(val);
    }
    return defaultVal;
}
